{
  "bell.title": "Varsler",
  "bell.open": "Vis varsler",
  "bell.unread.one": "{count} ulest",
  "bell.unread.other": "{count} uleste",
  "bell.awaiting.one": "{count} venter på svar",
  "bell.awaiting.other": "{count} venter på svar",
  "bell.empty": "Ingenting nytt akkurat nå.",
  "bell.empty_hint": "Nye bestillinger, endringer og avbestillinger dukker opp her.",
  "bell.mark_all_read": "Merk alle som lest",
  "bell.settings": "Innstillinger for varsler",
  "bell.error": "Varslene kunne ikke hentes.",
  "bell.confirm": "Bekreft",
  "bell.reject": "Avvis",
  "bell.reject_reason": "Avvist av verkstedet",
  "bell.handled": "Allerede håndtert",
  "bell.unknown_customer": "Kunde uten navn",
  "bell.unknown_service": "Tjeneste",
  "bell.kind.booking_requested": "Ny bestilling å bekrefte",
  "bell.kind.booking_created": "Ny bestilling",
  "bell.kind.booking_rescheduled": "Kunden har endret tid",
  "bell.kind.booking_cancelled": "Kunden har avbestilt",
  "bell.kind.email_failed": "E-posten kom ikke fram",
  "bell.body.booking_requested": "{customer} vil bestille {service} {when}. Bekreft eller avvis.",
  "bell.body.booking_created": "{customer} har bestilt {service} {when}.",
  "bell.body.booking_rescheduled": "{customer} har flyttet {service} til {when}.",
  "bell.body.booking_cancelled": "{customer} har avbestilt {service} {when}.",
  "bell.body.email_failed": "En e-post kom i retur. Kunden vet ikke om bestillingen sin — ring dem.",
  "settings.nav.notifications": "Varsler",
  "settings.notifications.heading": "Dine varsler",
  "settings.notifications.body": "Dette gjelder deg, ikke verkstedet. Endrer du her, endres ingenting for kollegene dine.",
  "settings.notifications.sound": "Spill en lyd",
  "settings.notifications.sound_hint": "Et kort signal når noe nytt dukker opp. Fint på et nettbrett i disken.",
  "settings.notifications.test_sound": "Test lyden",
  "settings.notifications.desktop": "Vis et varsel på maskinen",
  "settings.notifications.desktop_hint": "Synlig også når fanen ligger i bakgrunnen. Nettleseren spør om lov først.",
  "settings.notifications.desktop_blocked": "Nettleseren har blokkert varsler. Slipp dem fram i nettleserens egne innstillinger.",
  "settings.notifications.kinds": "Hva vil du høre om?",
  "settings.notifications.kinds_hint": "Avhukede hendelser havner fortsatt i klokka, men uten lyd.",
  "settings.notifications.sound_blocked": "Nettleseren lot ikke lyden spilles. Klikk et sted på siden og prøv igjen.",
  "notifications.all_caught_up": "Alt er lest. Ingenting venter på svar.",
  "notifications.filter.all": "Alt",
  "notifications.filter.unread_only": "Bare uleste",
  "notifications.load_more": "Vis flere",
  "notifications.empty_filtered": "Ingenting passer med filteret.",
  "notifications.empty_filtered_hint": "Prøv et annet utvalg, eller velg Alt for å se hele listen.",
  "notifications.to_calendar": "Til kalenderen",
  "notifications.messaging.test_message": "ColorGlo: testmelding fra siden Integrasjoner.",
  "notifications.sms.booking_confirmed": "Timen din hos {workshop_name} er booket: {date} kl. {time}, {location}. Bookingnummer {reference}. Endre eller avbestill: {manage_link}",
  "notifications.sms.reminder": "Påminnelse: du har time hos {workshop_name} {date} kl. {time}, {location}. Endre eller avbestill: {manage_link}",
  "notifications.sms.rescheduled": "Timen din hos {workshop_name} er flyttet til {date} kl. {time}. Se bookingen: {manage_link}",
  "notifications.sms.cancelled": "Timen din hos {workshop_name} {date} kl. {time} er avbestilt. Velkommen til å bestille en ny time.",
  "bell.kind.shop_order_approved": "Bestilling godkjent",
  "bell.kind.shop_order_rejected": "Bestilling avvist",
  "bell.kind.shop_order_shipped": "Bestilling sendt",
  "bell.body.shop_order_approved": "HQ har godkjent ordre {number}.",
  "bell.body.shop_order_rejected": "HQ har avvist ordre {number}.",
  "bell.body.shop_order_shipped": "Ordre {number} er sendt. Følgeseddelen ligger på ordren.",
  "bell.kind.shop_order_cancelled": "Bestilling avbrutt av HQ",
  "bell.body.shop_order_cancelled": "HQ har avbrutt ordre {number}."
}
